module.exports = __webpack_public_path__ + "assets/img/0865bff3162131b90369f2aea084ee45.svg";